import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;

const axios = createAxiosInstance(URL);

export const fetchOrderWorkers = (params) => {
    return axios.get(`/api/v1/orders/orders/${params.order}/workers/`, { params });
};

export const fetchWorkerRoles = async () => {
    const { results = [] } = await axios.get('/api/v1/orders/workers/roles/');

    return results;
};

export const fetchCustomerMembers = (params) => {
    return axios.get('/api/v1/customers/customers_members/', { params });
};

export const addWorkerToOrder = (order, data) => {
    return axios.post(`/api/v1/orders/orders/${order}/create_worker/`, data);
};

export const removeWorkerFromOrder = (order, workerId) => {
    return axios.delete(`/api/v1/orders/orders/${order}/destroy_worker/${workerId}/`);
};

export const fetchCustomersEmployees = (params) => {
    return axios.get('/api/v1/customers/employees/', { params });
};

export const fetchCustomersMembersLanguages = () => {
    return axios.get('/api/v1/customers/customers_members/languages/');
};

export const fetchEmployeesLanguages = () => {
    return axios.get('/api/v1/customers/employees/languages/');
};
